export default "__VITE_ASSET__qEkw_p9e__"